import { useEffect, useState } from "react";
import { TERMS } from "@/lib/testIds";
import { TERMS_SECTIONS } from "@/data/staticContent";

export const Terms = () => {
  const [active, setActive] = useState(TERMS_SECTIONS[0].id);

  useEffect(() => {
    const handler = () => {
      const y = window.scrollY + 180;
      let current = TERMS_SECTIONS[0].id;
      for (const s of TERMS_SECTIONS) {
        const el = document.getElementById(`terms-${s.id}`);
        if (el && el.offsetTop <= y) current = s.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <main data-testid={TERMS.root} className="pb-24">
      <section className="mx-auto max-w-[1400px] px-5 pt-20 md:px-10 md:pt-32">
        <p className="text-[10px] uppercase tracking-[0.28em] text-muted-foreground md:text-xs">
          Legal · Effective February 2026
        </p>
        <h1 className="mt-5 font-display text-5xl font-medium leading-[0.95] tracking-tight md:mt-8 md:text-8xl">
          Terms &<br />
          <span className="italic">conditions</span>.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground/70 md:mt-10 md:text-lg">
          Plain-english rules of the road for using StayEasy. Read them once
          and they'll rarely surprise you again.
        </p>
      </section>

      <section className="mx-auto mt-16 grid max-w-[1400px] grid-cols-1 gap-12 px-5 md:mt-24 md:grid-cols-[240px_1fr] md:gap-20 md:px-10">
        {/* TOC */}
        <aside className="md:sticky md:top-[110px] md:h-fit" data-testid={TERMS.toc}>
          <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground md:text-xs">
            Contents
          </p>
          <ul className="mt-5 space-y-2">
            {TERMS_SECTIONS.map((s) => (
              <li key={s.id}>
                <a
                  href={`#terms-${s.id}`}
                  className={`block border-l-2 pl-3 text-sm transition-colors duration-200 ${
                    active === s.id
                      ? "border-primary text-foreground"
                      : "border-transparent text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </aside>

        {/* Body */}
        <article className="max-w-3xl">
          {TERMS_SECTIONS.map((s) => (
            <section
              key={s.id}
              id={`terms-${s.id}`}
              data-testid={TERMS.section(s.id)}
              className="scroll-mt-32 border-t border-foreground/10 py-10 first:border-t-0 first:pt-0"
            >
              <h2 className="font-display text-2xl font-medium tracking-tight md:text-3xl">
                {s.title}
              </h2>
              <div className="mt-5 space-y-4 text-base leading-relaxed text-foreground/85">
                {s.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </article>
      </section>
    </main>
  );
};

export default Terms;
